// panel-wrapper.component.ts
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
    <div class="card ">
      <h3 class="card-header mb-0"><span><em class="fa {{to.labelIcon||''}}"></em> {{ props.label }}</span> <mat-icon *ngIf="(!props.hasOwnProperty('tooltipType')||props.tooltipType=='plain')&&props['tooltip']"
            matTooltip="{{ props['tooltip'] }}"
            class="icon mt-1"
            matTooltipPosition="right"
            >help</mat-icon>
            <ng-container *ngIf="props.tooltipType=='html'&&props['tooltip']">
        <em class="fas fa-question-circle icon" [ngbTooltip]="htmlContent" #t="ngbTooltip" (click)="t.open(); $event.stopPropagation()" triggers="click:blur"  tooltipClass="my-custom-class" placement="right"></em>
  
  <ng-template #htmlContent class="ml-4">
  <div [innerHTML]="props['tooltip']"></div>
  </ng-template>
  </ng-container>
          </h3>
      <div class="card-body pt-0">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
  styles:[`
  .icon {
            font-size: 14px;
            margin-left:5px;
            color: #817c7c;
        }
        .my-custom-class .tooltip-inner {
      max-width: 300px;
      background-color:#DFDFDF;
      font-size: 14px;
      margin-left: 5px;
      color:black !important;
    }
    .my-custom-class .arrow::before {
      border-top-color: #7e7a7a;
    }
    .tooltip .tooltip-arrow {
        margin-left: 5px
    }
   
  `],
  standalone:true,
  imports:[
    NgbTooltipModule,MatTooltipModule,CommonModule
  ]
})
export class PanelFieldWrapper extends FieldWrapper {
}